var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',[_c('horizontal-nav',{attrs:{"set_sub_view":"","show_display":false,"items":_vm.items}}),_c('horizontal-nav',{attrs:{"set_sub_sub_view":"","show_display":false,"items":_vm.sub_items}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }